// Module
var code = "<h2 class=\"interiorSectionHeading\">Forbearance</h2> <p><strong>Forbearance</strong> is a period of time when your lender <strong>temporarily reduces or suspends</strong> your regular payments.</p> ";
// Exports
export default code;